import { Box, Card, CardContent, TextField } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import React from "react";
import Chart from "react-apexcharts";
import { BoxedLoader } from "../../BoxedLoader";
import offerTypes from "../../../utils/offerTypes";
import transport from "../../../utils/transport";
import departureCity from "../../../utils/departureCity";
import period from "../../../utils/period";
import boardType from "../../../utils/boardType";
import { useTranslation } from "react-i18next";

const PredictedTrendsWithSelectsComparison = ({ categories, data }) => {
  const { t } = useTranslation();

  const theme = useTheme();

  const chart: any = data
    ? {
        series: [
          {
            name: "Average Greece",
            type: "line",
            data: data.avg1,
            color: "#f4b73f",
          },
          {
            name: "Average Egypt",
            type: "line",
            data: data.avg2,
            color: "#1e4354",
          },
          {
            name: "Average all",
            type: "line",
            data: data.avgAll,
            color: "#5fc1f2",
          },
        ],
        options: {
          chart: {
            background: "transparent",
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          colors: ["#f4b73f", "#1e4354", "#5fc1f2"],
          grid: {
            borderColor: theme.palette.divider,
            strokeDashArray: 2,
          },
          legend: {
            position: "top",
            horizontalAlign: "right",
            labels: {
              colors: theme.palette.text.secondary,
            },
            show: true,
          },
          plotOptions: {
            bar: {
              columnWidth: "40%",
            },
          },
          stroke: {
            colors: ["transparent"],
            show: true,
            width: 2,
          },
          theme: {
            mode: theme.palette.mode,
          },
          tooltip: {
            theme: theme.palette.mode,
          },
          xaxis: {
            axisBorder: {
              show: true,
              color: theme.palette.divider,
            },
            axisTicks: {
              show: true,
              color: theme.palette.divider,
            },
            categories: categories,
            labels: {
              style: {
                colors: theme.palette.text.secondary,
              },
            },
          },
          yaxis: {
            axisBorder: {
              color: theme.palette.divider,
              show: true,
            },
            axisTicks: {
              color: theme.palette.divider,
              show: true,
            },
            labels: {
              style: {
                colors: theme.palette.text.secondary,
              },
            },
          },
        },
      }
    : {};

  return (
    <Card>
      <CardContent>
        <Box sx={{ pt: 3 }}>
          <TextField
            label={t(`other.offer_type`)}
            name="recreation"
            select
            SelectProps={{ native: true }}
            variant="outlined"
            sx={{ mx: 3 }}
          >
            {offerTypes.map((option) => (
              <option key={option.value} value={option.value}>
                {t(`utils.${option.label.toLocaleLowerCase()}`)}
              </option>
            ))}
          </TextField>
          <TextField
            label={t(`main.transportType`)}
            name="sort"
            select
            SelectProps={{ native: true }}
            variant="outlined"
            sx={{ mx: 3 }}
          >
            {transport.map((option) => (
              <option key={option.value} value={option.value}>
                {t(`utils.${option.label.toLocaleLowerCase()}`)}
              </option>
            ))}
          </TextField>
          <TextField
            label={t(`main.departurecity`)}
            name="sort"
            select
            SelectProps={{ native: true }}
            variant="outlined"
            sx={{ mx: 3 }}
          >
            {departureCity.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </TextField>
          <TextField
            label={t(`main.period`)}
            name="sort"
            select
            SelectProps={{ native: true }}
            variant="outlined"
            sx={{ mx: 3 }}
          >
            {period.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </TextField>
          <TextField
            label={t(`other.board_type`)}
            name="sort"
            select
            SelectProps={{ native: true }}
            variant="outlined"
            sx={{ mx: 3 }}
          >
            {boardType.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </TextField>
        </Box>
        {!data && <BoxedLoader height={"390px"} />}
        {data && <Chart height={390} {...chart} />}
      </CardContent>
    </Card>
  );
};

export default PredictedTrendsWithSelectsComparison;
